export default __webpack_public_path__ + "static/media/Snd_CV.5e5ef2bd.mp3";